<template>
  <div>
    <form-wizard
      class="pt-0 mt-0"
      shape="tab"
      title=""
      subtitle=""
      color="#0081FF"
      next-button-text="Next"
      finish-button-text="Save"
      @on-complete="saveAEP"
    >
      <tab-content
        title="Upload"
        icon="mdi mdi-upload"
      >
        <v-row>
          <v-col
            cols="12"
            md="5"
          >
            <v-img
              width="320"
              height="240"
              contain
              class="grey darken-4 m-b-20 m-l-30"
              src="@/assets/placeholder.png"
            />
            <!--v-file-input
              v-model="aepFile"
              class="pointer"
              placeholder="Upload a new AEP"
              truncate-length="15"
              label="AEP File"
              style="width: 350px;"
              show-size
              accept=".aep,application/vnd.audiograph"
              prepend-icon="mdi-paperclip"
              :loading="fileLoading"
              @change="fileUpload(aepFile)"
            /-->

            <v-file-input
              v-model="zipFile"
              class="pointer"
              placeholder="Upload a new ZIP"
              truncate-length="15"
              label="ZIP File"
              style="width: 350px;"
              show-size
              accept=".zip,application/zip"
              prepend-icon="mdi-paperclip"
              :loading="zipFileLoading"
              @change="zipFileUpload(zipFile)"
            />
          </v-col>
          <v-col
            cols="12"
            md="7"
          >
            <base-card class="mb-3">
              <v-card-title>Template info</v-card-title>
              <v-card-text>
                <v-divider />
                <div>
                  <div
                    class="d-flex justify-space-between"
                  >
                    <p
                      class="text--disabled mb-1 text-18 mr-2"
                    >
                      Name:
                    </p>
                    <p
                      v-if="uploadedAepFile.name"
                      class="mb-1 text-18"
                    >
                      <v-text-field
                        v-model.trim="uploadedAepFile.name"
                        dense
                        outlined
                        style="min-width: 350px;"
                        hide-details
                      />
                    </p>
                  </div>
                  <div
                    class="d-flex justify-space-between"
                  >
                    <p
                      class="text--disabled mb-1 text-18 mr-2"
                    >
                      Size:
                    </p>
                    <p
                      v-if="uploadedAepFile.size"
                      class="mb-1 text-18"
                    >
                      {{ (uploadedAepFile.size/1000000).toFixed(1) }} MB
                    </p>
                  </div>
                  <div
                    class="d-flex justify-space-between"
                  >
                    <p
                      class="text--disabled mb-1 text-18 mr-2"
                    >
                      Files:
                    </p>
                    <p
                      v-if="uploadedAepFile.files.count"
                      class="mb-1 text-18"
                    >
                      {{ uploadedAepFile.files.count }}
                    </p>
                  </div>
                  <div
                    class="d-flex justify-space-between"
                  >
                    <p
                      class="text--disabled mb-1 text-18 mr-2"
                    >
                      Last Modified Date:
                    </p>
                    <p
                      v-if="uploadedAepFile.lastModifiedDate"
                      class="mb-1 text-18"
                    >
                      {{ moment.utc(uploadedAepFile.lastModifiedDate).format('D MMM HH:mm:ss') }}
                    </p>
                  </div>
                  <div
                    class="d-flex justify-space-between"
                    style="flex-flow: wrap;"
                  >
                    <p
                      class="text--disabled mb-1 text-18 mr-2"
                    >
                      URL:
                    </p>
                    <p
                      class="text-success mb-1 text-18"
                      style="word-break: break-all;"
                    >
                      <a
                        :href="uploadedAepFile.url"
                        target="_blank"
                      >{{ uploadedAepFile.url }}</a>
                    </p>
                  </div>
                </div>
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
      </tab-content>
      <tab-content
        title="Layers"
        icon="mdi mdi-layers"
      >
        <v-row>
          <v-col
            cols="12"
            md="7"
          >
            <base-card :data-loading="fileParsing">
              <v-card-title>
                <div class="card-title mb-0">
                  Project structure: {{ uploadedAepFile.name }}
                </div>
              </v-card-title>
              <v-card-text>
                <v-sheet
                  max-height="560"
                  class="overflow-y-auto"
                >
                  <table class="tree-table">
                    <thead>
                      <tr>
                        <th />
                        <th>Name</th>
                        <th>Dimension</th>
                        <th>Duration</th>
                        <th>FR</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          v-if="!uploadedAepFile.project.compositions.length"
                          colspan="5"
                          class="pa-4 text--disabled text-center"
                        >
                          No data
                        </td>
                      </tr>
                      <template v-for="comp in uploadedAepFile.project.compositions">
                        <tr
                          :key="comp.id"
                        >
                          <td
                            class="pointer"
                            @click="comp.open = !comp.open"
                          >
                            <span v-if="comp.layers.length && !comp.open">&gt;</span>
                            <span v-if="comp.layers.length && comp.open">v</span>
                          </td>
                          <td>
                            <v-menu
                              v-model="comp.menu"
                              :close-on-content-click="false"
                              :nudge-width="130"
                              offset-x
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  class="hover-name"
                                  v-on="on"
                                >
                                  {{ comp.name }}
                                </span>
                              </template>

                              <v-card>
                                <v-list>
                                  <v-list-item>
                                    <v-list-item-content class="pa-0">
                                      <v-list-item-title>{{ comp.name }}</v-list-item-title>
                                      <v-list-item-subtitle>{{ comp.footage_width }}x{{ comp.footage_height }}, {{ comp.footage_seconds }} sec</v-list-item-subtitle>
                                      <v-list-item-subtitle>{{ comp.layers.length }} layers</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>

                                <v-divider class="ma-0" />

                                <v-btn
                                  depressed
                                  small
                                  class="primary--text ma-2 ml-3"
                                  color="primary lighten-5"
                                  @click="setRootComposition(comp)"
                                >
                                  <v-icon
                                    left
                                    color="primary"
                                  >
                                    mdi-video
                                  </v-icon>
                                  Set as Root Composition
                                </v-btn>
                              </v-card>
                            </v-menu>

                            <v-chip
                              v-if="comp.name === uploadedAepFile.root.name"
                              color="primary lighten-5"
                              x-small
                              text-color="primary"
                            >
                              root
                            </v-chip>
                            <i
                              v-if="comp.selected"
                              class="v-icon notranslate text-caption primary--text text--lighten-3 mdi mdi-checkbox-blank-circle theme--light ml-1"
                              style="padding-bottom: 2px;"
                            />
                          </td>
                          <td>{{ comp.footage_width }}x{{ comp.footage_height }}</td>
                          <td>{{ comp.footage_seconds.toFixed(2) }} sec</td>
                          <td>{{ comp.footage_framerate }}</td>
                        </tr>
                        <tr
                          v-for="layer in comp.layers"
                          v-show="comp.open"
                          :key="'layer'+comp.id+'l'+layer.index"
                        >
                          <td />
                          <td class="pl-5">
                            <v-menu
                              v-model="layer.menu"
                              :close-on-content-click="false"
                              :nudge-width="130"
                              offset-x
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  class="hover-name"
                                  v-on="on"
                                >
                                  {{ layer.name }}
                                </span>
                              </template>

                              <v-card>
                                <v-list>
                                  <v-list-item>
                                    <v-list-item-content class="pa-0">
                                      <v-list-item-title>{{ layer.name }}</v-list-item-title>
                                      <v-list-item-subtitle v-if="layer.text">
                                        text layer
                                      </v-list-item-subtitle>
                                      <v-list-item-subtitle>
                                        {{ layer.effects }} effects
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>

                                <v-divider class="ma-0" />

                                <v-btn
                                  depressed
                                  small
                                  class="primary--text ma-2 ml-3"
                                  color="primary lighten-5"
                                  @click="addToAssets(comp, layer)"
                                >
                                  <v-icon
                                    left
                                    color="primary"
                                  >
                                    mdi-plus
                                  </v-icon>
                                  Add to Dynamic Assets
                                </v-btn>
                              </v-card>
                            </v-menu>
                            <span
                              v-if="!layer.name"
                              class="text--disabled"
                            >N/A</span>

                            <i
                              v-if="layer.selected"
                              class="v-icon notranslate text-caption primary--text text--lighten-3 mdi mdi-checkbox-blank-circle theme--light ml-1"
                              style="padding-bottom: 2px;"
                            />
                          </td>
                          <td />
                          <td />
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </v-sheet>
              </v-card-text>
            </base-card>
          </v-col>
          <v-col
            cols="12"
            md="5"
          >
            <base-card>
              <v-card-title class="pb-1">
                <div class="card-title mb-0">
                  Dynamic Assets
                </div>
              </v-card-title>
              <v-card-text>
                <div
                  class="d-flex justify-space-between flex-wrap"
                >
                  <p
                    class="text--disabled mb-1 text-16 mr-2"
                  >
                    Root Composition:
                  </p>
                  <p class="text-primary mb-1 text-16">
                    {{ uploadedAepFile.root.name }}
                  </p>
                  <p
                    v-if="!uploadedAepFile.root.name"
                    class="text-red mb-1 text-18"
                  >
                    Not found. Please set the root
                  </p>
                </div>
                <v-divider class="my-2 mb-4" />

                <draggable
                  class="list-group"
                  :list="uploadedAepFile.props"
                  ghost-class="ghost"
                  group="people"
                  v-bind="dragOptions"
                >
                  <transition-group
                    type="transition"
                    name="flip-list"
                  >
                    <v-row
                      v-for="(prop, i) in uploadedAepFile.props"
                      :key="prop.layer + i"
                      class="mt-0 pt-0"
                      style="padding-bottom:4px;"
                    >
                      <v-col
                        cols="12"
                        md="8"
                        class="mt-0 pt-0 mb-0 pb-0"
                      >
                        <div class="d-flex justify-space-between">
                          <v-icon class="mr-2 pointer">
                            mdi-cursor-move
                          </v-icon>
                          <input
                            class="prop-input"
                            readonly
                            :value="prop.layer"
                          >
                          <select
                            v-model="prop.type"
                            class="form-select"
                            style="width: 80px;"
                          >
                            <option>
                              Text
                            </option>
                            <option>Image</option>
                            <option>Media</option>
                            <option>Audio</option>
                            <option>Video</option>
                          </select>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        class="mt-0 pt-1 pl-0 pr-0  mb-0 pb-0 text--disabled"
                      >
                        <div class="d-flex justify-space-between">
                          <span>{{ prop.comp }}</span>
                          <v-icon
                            class="ml-2 pointer"
                            color="error"
                            @click="removeFromAssets(prop)"
                          >
                            mdi-close
                          </v-icon>
                        </div>
                      </v-col>
                    </v-row>
                  </transition-group>
                </draggable>
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
      </tab-content>
      <tab-content
        title="Info"
        icon="mdi mdi-layers"
      >
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <base-card :data-loading="fileParsing">
              <v-card-title>
                <div class="card-title mb-0">
                  Source Info & Comments
                </div>
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model.trim="uploadedAepFile.sourceURL"
                  dense
                  outlined
                  append-icon="mdi-link"
                  label="Source URL"
                />
                <v-textarea
                  v-model="uploadedAepFile.description"
                  append-icon="mdi-comment-text"
                  label="Template description"
                  rows="2"
                  auto-grow
                  dense
                  outlined
                  counter
                />
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
      </tab-content>
      <tab-content
        title="Complete"
        icon="mdi mdi-content-save"
      >
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <base-card>
              <v-card-title class="pb-0">
                <div class="card-title mb-0">
                  New Template
                </div>
              </v-card-title>
              <v-card-text>
                <v-row
                  class="mt-0 pt-0"
                >
                  <v-col
                    cols="12"
                    md="4"
                    class="pb-0"
                  >
                    <v-text-field
                      v-model.trim="uploadedAepFile.name"
                      dense
                      label="Name"
                      outlined
                      style="min-width: 350px;"
                      hide-details
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="8"
                    class="pb-0 pt-1"
                  >
                    <p
                      class="mb-1 text-16"
                      style="word-break: break-all;"
                    >
                      <a
                        :href="uploadedAepFile.url"
                        target="_blank"
                        class="mr-4"
                      >{{ uploadedAepFile.url }}</a>
                      <br>
                      <span class="pr-1 text--disabled">Root:</span>
                      <span v-if="uploadedAepFile.root.name">
                        {{ uploadedAepFile.root.name }} {{ uploadedAepFile.root.compW }}x{{ uploadedAepFile.root.compH }}, {{ uploadedAepFile.root.compDur.toFixed(2) }} sec
                      </span>

                      <span
                        v-if="!uploadedAepFile.root.name"
                        class="text-red mb-1 text-18"
                      >
                        Not found. Please set the root
                      </span>
                    </p>
                  </v-col>
                </v-row>

                <v-divider class="my-2" />

                <v-row
                  class="table-header"
                >
                  <v-col
                    cols="12"
                    md="5"
                    class="mt-0 pt-0 mb-0 pb-1"
                  >
                    Asset Display Name & Type
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    class="mt-0 pt-1 pl-0 pr-0 mb-0 pb-1"
                  >
                    Composition
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    class="mt-0 pt-1 pl-0 pr-0 mb-0 pb-1"
                  >
                    Layer
                  </v-col>
                </v-row>
                <draggable
                  class="list-group"
                  :list="uploadedAepFile.props"
                  ghost-class="ghost"
                  group="people"
                  v-bind="dragOptions"
                >
                  <transition-group
                    type="transition"
                    name="flip-list"
                  >
                    <v-row
                      v-for="(prop, i) in uploadedAepFile.props"
                      :key="prop.layer + i"
                      class="mt-0 pt-0"
                      style="padding-bottom:4px;"
                    >
                      <v-col
                        cols="12"
                        md="5"
                        class="mt-0 pt-0 mb-0 pb-0"
                      >
                        <div class="d-flex">
                          <v-icon class="mr-2 pointer">
                            mdi-cursor-move
                          </v-icon>
                          <input
                            v-model="prop.displayName"
                            class="prop-input"
                            style="width: 300px;"
                          >
                          <select
                            v-model="prop.type"
                            class="form-select ml-2"
                            style="width: 80px;"
                          >
                            <option>
                              Text
                            </option>
                            <option>Image</option>
                            <option>Media</option>
                            <option>Audio</option>
                            <option>Video</option>
                          </select>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="3"
                        class="mt-0 pt-1 pl-0 pr-0  mb-0 pb-0"
                      >
                        <span>{{ prop.comp }}</span>
                        <span> ({{ prop.compW }}x{{ prop.compH }}), {{ prop.compDur.toFixed(2) }} sec</span>
                      </v-col>
                      <v-col
                        cols="12"
                        md="4"
                        class="mt-0 pt-1 pl-0 pr-0  mb-0 pb-0"
                      >
                        <div class="d-flex justify-space-between">
                          <span>{{ prop.layer }}</span>
                          <v-icon
                            class="ml-2 mr-2 pointer"
                            color="error"
                            @click="removeFromAssets(prop)"
                          >
                            mdi-close
                          </v-icon>
                        </div>
                      </v-col>
                    </v-row>
                  </transition-group>
                </draggable>
              </v-card-text>
            </base-card>
          </v-col>
        </v-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
  import { FormWizard, TabContent } from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import draggable from 'vuedraggable'
  import { aepProjectToJsonAPI } from '../../../store/converters'

  export default {
    name: 'NewAEP',
    metaInfo: {
      title: 'New AEP',
    },
    components: {
      FormWizard,
      TabContent,
      draggable,
    },
    data () {
      return {
        aepFile: null,
        zipFile: null,
        fileLoading: false,
        zipFileLoading: false,
        fileParsing: false,
        uploadedAepFile: {
          size: 0,
          name: '',
          lastModifiedDate: null,
          url: '',
          project: {
            compositions: [],
          },
          root: { name: '', compDur: 0 },
          props: [],
          files: { count: 0, dir: '', aep: '' },
          sourceURL: '',
          description: '',
        },
        polling: null,
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      dragOptions () {
        return {
          animation: 200,
          group: 'description',
          disabled: false,
        }
      },
      isFormValid () {
        if (!(this.uploadedAepFile.name.length >= 3 && this.uploadedAepFile.name.length <= 255)) {
          return false
        }
        if (!this.uploadedAepFile.url) {
          return false
        }
        if (!this.uploadedAepFile.root.name) {
          return false
        }
        return true
      },
    },
    watch: {
    },
    created () {
      this.loadData()
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      fileUpload (fileObj) {
        if (this.fileLoading) return

        this.fileLoading = true

        const file = new FormData()
        file.append('uploadfile', fileObj, fileObj.name)

        const params = {
          file,
          name: fileObj.name,
          // instanceId: this.channel.instance.id,
        }

        this.$store.dispatch('ftpUpload', params)
          .then((result) => {
            this.uploadedAepFile.size = fileObj.size
            this.uploadedAepFile.name = fileObj.name
            this.uploadedAepFile.lastModifiedDate = fileObj.lastModifiedDate
            this.uploadedAepFile.url = result.url

            this.fileLoading = false

            // console.log('result', result)

            this.fileParsing = true

            this.$store.dispatch('aepParse', { url: result.url })
              .then((project) => {
                console.log('project', project)

                this.uploadedAepFile.props = []

                if (project.compositions && project.compositions.length) {
                  for (let i = 0; i < project.compositions.length; i += 1) {
                    project.compositions[i].open = false
                    project.compositions[i].menu = false
                    project.compositions[i].selected = false

                    if (project.compositions[i].name.toLowerCase() === 'main') {
                      this.uploadedAepFile.root = {
                        name: project.compositions[i].name,
                        compW: project.compositions[i].footage_width,
                        compH: project.compositions[i].footage_height,
                        compDur: project.compositions[i].footage_seconds,
                        compFR: project.compositions[i].footage_framerate,
                      }
                    }

                    for (let j = 0; j < project.compositions[i].layers.length; j += 1) {
                      project.compositions[i].layers[j].selected = false
                      project.compositions[i].layers[j].menu = false

                      const l = project.compositions[i].layers[j]

                      if (l.name.includes('NP.DYN')) {
                        project.compositions[i].selected = true
                        project.compositions[i].layers[j].selected = true

                        let type = 'Text'
                        if (l.name.includes('.IMG.')) {
                          type = 'Image'
                        }
                        if (l.name.includes('.VID.')) {
                          type = 'Video'
                        }

                        this.uploadedAepFile.props.push({
                          layer: l.name,
                          displayName: l.name,
                          type: type,
                          comp: project.compositions[i].name,
                          compW: project.compositions[i].footage_width,
                          compH: project.compositions[i].footage_height,
                          compDur: project.compositions[i].footage_seconds,
                          compFR: project.compositions[i].footage_framerate,
                        })
                      }
                    }
                  }
                }
                this.uploadedAepFile.project = project

                /*                this.$store.commit('showSnackbar', {
                                  text: 'Logo has been successfully updated',
                                  timeout: 3000,
                                  color: 'success',
                                }) */
              })
              .catch((errorMsg) => {
                this.$store.commit('showSnackbar', {
                  text: errorMsg,
                  timeout: 6000,
                  color: 'error',
                })
              })
              .finally(() => {
                this.fileParsing = false
              })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
      },
      zipFileUpload (fileObj) {
        if (this.zipFileLoading) return

        this.zipFileLoading = true

        const file = new FormData()
        file.append('uploadfile', fileObj, fileObj.name)

        const params = {
          file,
          name: fileObj.name,
          // instanceId: this.channel.instance.id,
        }

        this.$store.dispatch('zipFtpUpload', params)
          .then((result) => {
            this.zipFileLoading = false

            this.uploadedAepFile.size = fileObj.size
            this.uploadedAepFile.name = result.aep
            this.uploadedAepFile.lastModifiedDate = fileObj.lastModifiedDate
            this.uploadedAepFile.url = result.url
            this.uploadedAepFile.files.count = result.files_count
            this.uploadedAepFile.files.dir = result.dir
            this.uploadedAepFile.files.aep = result.aep

            this.fileLoading = false

            console.log('result', result)

            this.fileParsing = true

            this.$store.dispatch('aepParse', { url: result.url })
              .then((project) => {
                console.log('project', project)

                this.uploadedAepFile.props = []

                if (project.compositions && project.compositions.length) {
                  for (let i = 0; i < project.compositions.length; i += 1) {
                    project.compositions[i].open = false
                    project.compositions[i].menu = false
                    project.compositions[i].selected = false

                    if (project.compositions[i].name.toLowerCase() === 'main') {
                      this.uploadedAepFile.root = {
                        name: project.compositions[i].name,
                        compW: project.compositions[i].footage_width,
                        compH: project.compositions[i].footage_height,
                        compDur: project.compositions[i].footage_seconds,
                        compFR: project.compositions[i].footage_framerate,
                      }
                    }

                    for (let j = 0; j < project.compositions[i].layers.length; j += 1) {
                      project.compositions[i].layers[j].selected = false
                      project.compositions[i].layers[j].menu = false

                      const l = project.compositions[i].layers[j]

                      if (l.name.includes('NP.DYN')) {
                        project.compositions[i].selected = true
                        project.compositions[i].layers[j].selected = true

                        let type = 'Text'
                        if (l.name.includes('.IMG.')) {
                          type = 'Image'
                        }
                        if (l.name.includes('.VID.')) {
                          type = 'Video'
                        }

                        this.uploadedAepFile.props.push({
                          layer: l.name,
                          displayName: l.name,
                          type: type,
                          comp: project.compositions[i].name,
                          compW: project.compositions[i].footage_width,
                          compH: project.compositions[i].footage_height,
                          compDur: project.compositions[i].footage_seconds,
                          compFR: project.compositions[i].footage_framerate,
                        })
                      }
                    }
                  }
                }
                this.uploadedAepFile.project = project

                /*                this.$store.commit('showSnackbar', {
                                  text: 'Logo has been successfully updated',
                                  timeout: 3000,
                                  color: 'success',
                                }) */
              })
              .catch((errorMsg) => {
                this.$store.commit('showSnackbar', {
                  text: errorMsg,
                  timeout: 6000,
                  color: 'error',
                })
              })
              .finally(() => {
                this.fileParsing = false
              })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.zipFileLoading = false
          })
      },
      setRootComposition (comp) {
        this.uploadedAepFile.root = {
          name: comp.name,
          compW: comp.footage_width,
          compH: comp.footage_height,
          compDur: comp.footage_seconds,
          compFR: comp.footage_framerate,
        }
      },
      addToAssets (comp, layer) {
        for (let i = 0; i < this.uploadedAepFile.props.length; i += 1) {
          const prop = this.uploadedAepFile.props[i]
          if (prop.comp === comp.name && prop.layer === layer.name) {
            return
          }
        }
        this.uploadedAepFile.props.push({
          layer: layer.name,
          displayName: layer.name,
          type: 'text',
          comp: comp.name,
          compW: comp.footage_width,
          compH: comp.footage_height,
          compDur: comp.footage_seconds,
          compFR: comp.footage_framerate,
        })
        comp.selected = true
        layer.selected = true
      },
      removeFromAssets (prop) {
        const index = this.uploadedAepFile.props.indexOf(prop)
        this.uploadedAepFile.props.splice(index, 1)

        for (let i = 0; i < this.uploadedAepFile.project.compositions.length; i += 1) {
          const comp = this.uploadedAepFile.project.compositions[i]
          if (prop.comp !== comp.name) {
            continue
          }

          for (let j = 0; j < comp.layers.length; j += 1) {
            if (prop.layer === comp.layers[j].name) {
              comp.layers[j].selected = false
            }
          }

          let compSelected = false
          for (let j = 0; j < comp.layers.length; j += 1) {
            if (comp.layers[j].selected) {
              compSelected = true
            }
          }
          comp.selected = compSelected
        }
      },
      loadData (silent) {
        return
        if (!silent) this.$store.commit('setPageLoader')
      },
      saveAEP () {
        if (!this.isFormValid) return

        this.$store.commit('setPageLoader')

        const newAEP = aepProjectToJsonAPI(this.uploadedAepFile)

        this.$store.dispatch('createAEPProject', newAEP)
          .then((res) => {
            this.$store.commit('showSnackbar', {
              text: 'The AEP template has been successfully added',
              timeout: 3000,
              color: 'success',
            })
            this.$router.push({
              name: 'DashboardPage',
              /*          params: {
                channel_id: channel.id,
              }, */
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
    },
  }
</script>

<style lang="scss">
.v-input--checkbox .v-input__control div {
  padding-top: 8px !important;
}

.tree-table {
  width: 100%;
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  color: #2c3e50;
}

.tree-table th {
  text-transform: uppercase;
  font-weight: 700;
  padding: 0.3rem;
}

.tree-table tr {
  border-bottom: 0.5px solid silver;
}

.tree-table tbody tr:hover {
}

.tree-table td {
  padding: 0.3rem;
}

.tree-table .hover-name:hover {
  background-color: #eee;
}

.prop-input {
  padding: 2px 5px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.form-select {
  cursor: pointer;
  display: block;
  width: 100%;
  padding: 2px 5px;
  -moz-padding-start: calc(0.75rem - 3px);
  font-weight: 400;
  color: #212529;
  background-color: #e9ecef;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.25rem center;
  background-size: 16px 12px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.wizard-header, .wizard-tab-content {
  padding-top: 0 !important;
}

.table-header {
  color: grey;
}
</style>
